import { inject } from "vue";

const useApi = () => inject('api');

export { useApi };